var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFunctionalTesting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FE8839;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x33_4_telephone"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M374.8,283.3c-2.7-2.7-6.4-4.2-10.2-4.2c-4.1-0.2-7.6,1.6-10.3,4.3l-22.7,23.2c-2.7,2.8-6.3,4.3-10.2,4.3 c-3.8,0-7.4-1.5-10.1-4.2L193.4,189.5c-5.6-5.6-5.7-15.1-0.2-20.8l23.1-23.7c5.5-5.6,5.4-14.7-0.1-20.2l-86.7-86.7 c-5.6-5.6-14.7-5.6-20.4,0l-50,50c-16.4,16.3-25.4,38.1-25.4,61.3c0,23.2,9,45,25.4,61.4l230,230c16.4,16.4,38.1,25.3,61.3,25.3 s45-9,61.3-25.3l50-50c5.6-5.6,5.6-14.7,0-20.4L374.8,283.3z M391.5,420.4c-21.8,21.8-60.1,21.8-81.9,0l-230-230 c-10.9-10.9-16.9-25.5-16.9-41c0-15.5,6-30.1,16.9-41l39.8-39.8l66.4,66.4l-13.1,13.4c-16.7,16.9-16.6,44.5,0.4,61.4L291,327.1 c8.1,8.1,18.9,12.6,30.4,12.6c11.7,0,22.7-4.6,30.8-13l12.5-12.8l66.7,66.7L391.5,420.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M249.4,120.5c71.7,0,130.1,58.4,130.1,130.1c0,8,6.4,14.4,14.4,14.4s14.4-6.4,14.4-14.4 c0-87.6-71.3-158.9-158.9-158.9c-8,0-14.4,6.4-14.4,14.4S241.5,120.5,249.4,120.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M249.4,178.3c39.9,0,72.3,32.4,72.3,72.3c0,8,6.4,14.4,14.4,14.4s14.4-6.4,14.4-14.4 c0-55.7-45.3-101.1-101.1-101.1c-8,0-14.4,6.4-14.4,14.4C235,171.8,241.5,178.3,249.4,178.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M249.4,62.7c103.6,0,187.9,84.3,187.9,187.9c0,8,6.4,14.4,14.4,14.4s14.4-6.4,14.4-14.4 c0-119.5-97.2-216.7-216.7-216.7c-8,0-14.4,6.4-14.4,14.4S241.5,62.7,249.4,62.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunctionalTesting);
export default __webpack_public_path__ + "static/media/Functional Testing.5189cb3dacfc21ad93c5e070d91dc532.svg";
export { ForwardRef as ReactComponent };